module.exports = __webpack_public_path__ + "media/img/partners/aesservice-logo-b8d43e41329d597b020b36b577ffa7bf.png";